<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import { tableData } from '@router/views/pages/ui/tables/data-advanced'
import searchHistoryDataSurch from '@router/views/pages/reviews/searchHistoryDataSurch'
import DatatableSearchSurcharge from './DatatableSearchSurcharge'
import AddLocalCharge from '@/src/components/localExpenses/AddLocalCharge'
import EditLocalCharge from '@/src/components/localExpenses/EditLocalCharge'
import EditFailLocalCharge from '@/src/components/localExpenses/EditFailLocalCharge'
import HarborManager from '@components/contract/harbor-manager'
import SurchargeManager from '@components/contract/surcharge-manager'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'

export default {
  name: 'DatatableLocalCharge',
  components: {
    DatatableSearchSurcharge,
    AddLocalCharge,
    EditLocalCharge,
    EditFailLocalCharge,
    HarborManager,
    SurchargeManager,
    HideColumnsTable,
  },
  props: {
    TableData: [Object, Array],
    TypeTable: String,
    contractsId: { type: Array, default: null },
    requestId: [Number, String],
    incOptions: [Array],
    countContracts: { type: Number, default: 0 },
    variationCell: { type: Array, default: null },
  },
  data() {
    return {
      contracts_ref: this.contractsId,
      request_id: this.requestId,
      typeTable: this.TypeTable,
      loandingDataDpM: false,
      inc_options: this.incOptions,
      tableData: [{ data: 'ok' }],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'age',
      sortDesc: false,
      fields: [],
      fieldList: [{ key: 'data' }],
      excludeFields: [],
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      historyData: [],
      loadingData: false,
      rowSet: {},
      localcharge_id: null,
      isTesting: false,
      contractPlaces: null,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  created() {
    if (!this.isTesting) {
      this.historyData = searchHistoryDataSurch.review
    }
    this.tableData = this.TableData[0]
    this.fieldList = this.TableData[1]
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
    this.$root.$on('closeModal', () => {
      this.saveModal()
    })
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    customFilterTable(row, filter) {
      var valuesRow = Object.values(row)
      let filtersSp = filter.split(' ')
      var flag = false
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          var valRowLC = String(valRow).toLowerCase()
          var filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      if (filtersFined.length === filtersSp.length) {
        flag = true
      }

      if (flag === true) {
        return true
      } else {
        return false
      }
    },
    saveModal() {
      this.showModal = false
      this.$emit('closeModal')
    },
    addRow(dataRow) {
      console.log(dataRow)
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'AddLocalCharge'
      this.modalTitle = 'Add / Include Localcharge'
      this.rowSet = dataRow
      this.loadingData = false
    },
    editRow(dataRow) {
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'EditLocalCharge'
      this.modalTitle = 'Edit Localcharge'
      this.localcharge_id = null
      this.localcharge_id = dataRow.id
      this.rowSet = dataRow
      this.loadingData = false
    },
    editFailRow(dataRow) {
      console.log(dataRow)
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'EditFailLocalCharge'
      this.modalTitle = 'Edit Wrong Localcharge'
      this.localcharge_id = null
      this.localcharge_id = dataRow.id
      this.rowSet = dataRow
      this.loadingData = false
    },
    addVariation(variation, column_key) {
      if (variation.split('(Error).').length > 1) {
        this.variation = variation.replace(' (Error).', '').trim()
        this.showModal = true
        if (column_key === 'surcharge') {
          this.modalComponent = 'SurchargeManager'
          this.modalTitle = 'Add Variation Surcharges'
        } else {
          this.modalComponent = 'HarborManager'
          this.modalTitle = 'Add Variation Harbors'
        }
      }
    },
    deleteRow(dataRow, goodOrFail) {
      this.localcharge_id = null
      this.localcharge_id = dataRow.id
      console.log(goodOrFail)
      this.$swal({
        title:
          'Are you sure you want to delete this Localcharge with ID ' +
          this.localcharge_id +
          '? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.loadingData = true
          axiosGetPost(
            'post',
            '/localCharges/deleteLocalcharge',
            {
              localcharge_id: this.localcharge_id,
              account_id: this.requestId,
              mode: goodOrFail,
            },
            'Delete Localcharge FCL'
          ).then((response) => {
            console.log(response)
            if (response.success) {
              this.$toastr.s('Success. Localcharge Deleted')
              this.tableData = this.tableData.filter(
                (item) => item.id !== dataRow.id
              )
            } else {
              this.$toastr.e('Attention. Error')
            }
            this.loadingData = false
            this.$root.$emit('closeModal')
            this.$root.$emit('update_table', 'localcharges', [goodOrFail])
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loandingDataDpM"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group row">
        <div class="col-md-12">
          <div class="d-flex mb-md-2">
            <!-- Inicio Table */******************************************************* */ -->
            <div class="mr-auto">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Inicio Ocultar columnsas /********************/**************-->

            <div>
                <HideColumnsTable
                  :field-list-fth="fieldList"
                  :type-table="'LocalCharge_'+typeTable"
                  @updateTableFieldsEmit="updateTableFieldsEmit"
                />
              </div>
            <!-- Fin Ocultar columnsas /********************/**************-->
            <!-- Search -->
            <div>
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>

            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              striped
              hover
              :items="tableData"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :filter-function="customFilterTable"
              @filtered="onFiltered"
            >
              <template
                v-slot:[`cell(`+vc+`)`]="row"
                v-for="vc in variationCell"
              >
                <span v-bind:key="vc" @click="addVariation(row.item[vc], vc)">
                  {{ row.item[vc] }}
                  <i
                    v-if="row.item[vc].split('(Error).').length > 1"
                    class="uil uil-pen"
                    style="color: blue"
                  ></i>
                </span>
              </template>

              <template v-slot:cell(actions)="row">
                <b-dropdown variant="success" dropleft class="ml-1 btn-sm">
                  <template slot="button-content">
                    <i>Options</i>
                  </template>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('search')"
                    style="color: ##0a399a"
                    @click="
                      searchSurchargeHistoryF(
                        row.item.ORIGIN,
                        row.item.DESTINY,
                        row.item.charge,
                        row.item.DIFFERENTIATOR,
                        row.item.calculationType
                      )
                    "
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-cloud-download"></i>
                      &nbsp; &nbsp;Search Surcharge
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('add')"
                    style="color: #0a399a"
                    @click="addRow(row.item)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-plus"></i>
                      &nbsp; &nbsp;Include
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('edit')"
                    style="color: #0a399a"
                    @click="editRow(row.item)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-edit"></i>
                      &nbsp; &nbsp;Edit
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('editFails')"
                    style="color: #0a399a"
                    @click="editFailRow(row.item)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-edit"></i>
                      &nbsp; &nbsp;Edit
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('delete')"
                    style="color: #0a399a"
                    @click="deleteRow(row.item, typeTable)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-trash"></i>
                      &nbsp; &nbsp;Delete
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <strong>Filtered {{ totalRows }} of {{ rows }} entries</strong>
              <div class="dataTables_paginate paging_simple_numbers float-left">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- {{ rows }} -->
                </ul>
              </div>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

          <!-- Fin Table */******************************************************* */ -->
        </div>
      </div>
    </div>
    <b-modal
      id="modal-lg"
      ref="requestFcl"
      v-model="showModal"
      size="lg"
      :title="modalTitle"
      title-class="font-18"
    >
      <div
        v-if="loadingData"
        class="row align-items-center justify-content-center"
        style="height: 300px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="primary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>

      <div v-else-if="modalErrorShow === true">
        <div
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <feather type="frown" class="icon-xxl icon-dual-info"></feather>
            <h6 class="text-muted">{{ modalError }}</h6>
          </div>
        </div>
      </div>
      <DatatableSearchSurcharge
        v-if="
          modalComponent === 'searchSurchargesHistory' && loadingData === false
        "
        :table-datap="historyData"
        type-tablep="rw_surcharge_history"
      />
      <AddLocalCharge
        v-if="modalComponent === 'AddLocalCharge' && loadingData === false"
        :request-id="request_id"
        :pre-load="rowSet"
      />
      <EditLocalCharge
        v-if="modalComponent === 'EditLocalCharge' && loadingData === false"
        :local-id="localcharge_id"
        @closeModal="saveModal"
      />
      <EditFailLocalCharge
        v-if="modalComponent === 'EditFailLocalCharge' && loadingData === false"
        :local-id="localcharge_id"
        @closeModal="saveModal"
      />
      <HarborManager
        v-if="modalComponent === 'HarborManager' && loadingData === false"
        :nameVariation="variation"
      />
      <SurchargeManager
        v-if="modalComponent === 'SurchargeManager' && loadingData === false"
        :nameVariation="variation"
      />

      <template v-slot:modal-footer>
        <b-button variant="light" @click="saveModal()">Close</b-button>
        <b-button
          v-if="
            loadingData === false &&
            modalErrorShow === false &&
            modalComponent === 'searchSurchargesHistory'
          "
          variant="primary"
          @click="saveModal"
        >
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-soft-info {
  color: #259cb5 !important;
  background-color: rgba(37, 194, 227, 0.2);
}

.badge-soft-pdp {
  color: #a243d3 !important;
  background-color: rgb(162 67 211 / 20%);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>